
import type { PropType } from 'vue'
import { defineComponent, reactive, watch } from 'vue'

import formatPriceToTenge from '@/modern/helpers/formatPriceToTenge'

// > services/payment-requests
import paymentRequestsAPI from '@/modern/modules/m-accounting-module/services/payment-requests.service'

//
import useVuelidate from '@vuelidate/core'
import { required, numeric } from '@vuelidate/validators'

import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: Boolean,
            default: false,
        },
        balance: {
            type: String as PropType<string | null>,
            default: 0
        }
    },
    emits: ['update:modelValue', 'close', 'deposited'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            isLoading: false,
            amount: null as string | null,
            comment: null as string | null,
            file: null as File | null
        })

        const state_form$ = useVuelidate({
            amount: { required, numeric },
            file: { required }
        }, state)

        const onClose = () => {
            if (props.disabled) return
            emit('close')
        }

        const onUpdateModelValue = (newValue: boolean) => {
            if (props.disabled) return
            emit('update:modelValue', newValue)
        }

        const onSubmit = async () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            try {
                state.isLoading = true

                const form_data = new FormData()
                form_data.append('amount', state.amount as string)
                form_data.append('file', state.file as File)
                
                if (state.comment) {
                    form_data.append('comment', state.comment as string)
                }

                await paymentRequestsAPI.depositBalance(form_data)

                notifications.notify({ type: 'success', title: 'Баланс пополнен' })
                emit('deposited')
            } catch (error) {
                console.error(error)
            } finally {
                state.isLoading = false
            }
        }

        watch(
            () => props.modelValue,
            (newValue) => {
                if (newValue === false) {
                    state.amount = null
                    state.comment = null
                    state.file = null
                    state_form$.value.$reset()
                }
            }
        )

        return {
            state,
            state_form$,
            onClose,
            onSubmit,
            onUpdateModelValue,
            formatPriceToTenge,
        }
    }
})
